import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/parametrizacao`

    return {
        grupoExame: {
            autocomplete(queryParms = {}) {

                return repository.post(`${baseUrl}/autocomplete-grupo-exame`, queryParms)
            },
        },
        exame: {
            autocomplete(queryParms = {}) {

                return repository.post(`${baseUrl}/autocomplete-exame`, queryParms)
            },
        },
        procedimentoCirurgico: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-procedimento-cirurgico?${urlUtil.serialize(queryParms)}`)
            },
        },
        especialidade: {
            autocomplete(queryParms = {}) {

                return repository.post(`${baseUrl}/autocomplete-especialidade`, queryParms)
            },
        },
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
    }
}